import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import "global/window";
import { AppModule } from "./app/app.module";
import { environment } from "environment";
(window as any).global = window;

declare global {
  interface Window {
    _paq?: any[];
  }
}

window._paq = window._paq || [];
(window as any)._pageSenseLoaded = false;
window._paq.push(['setRequestMethod', 'beacon']);

// Sumo Logic RUM
function initSumoRum(): void {
  if (!environment.enableSumoRum || !environment.sumoRum?.collectionSourceUrl) {
    return;
  }
  import('@sumologic/opentelemetry-rum').then(({ initialize }) => {
    initialize({
      collectionSourceUrl:   environment.sumoRum.collectionSourceUrl,
      serviceName:           environment.sumoRum.serviceName,
      applicationName:       environment.sumoRum.applicationName,
      deploymentEnvironment: environment.sumoRum.deploymentEnvironment,
      collectErrors:         true,
      samplingProbability:   1,
      propagateTraceHeaderCorsUrls: environment.sumoRum.propagateTraceHeaderCorsUrls, 
      ignoreUrls:                   environment.sumoRum.ignoreUrls,  
    });
  });
}

// Load PageSense dynamically
function loadPageSense(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!environment.enablePagesense || !environment.pagesenseUrl) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = environment.pagesenseUrl;
    script.async = true;

    script.onload = () => {
      (window as any)._pageSenseLoaded = true;
      resolve();
    };

    script.onerror = () =>
      reject(`Failed to load PageSense script`);

    document.head.appendChild(script);
  });
}

// Bootstrap app after PageSense (if enabled)
initSumoRum();  // before bootstrapModule

loadPageSense().finally(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
